/* ============================================================
   tcg-cart.js — helper compartido para agregar al carrito.
   Único punto de POST /cart/add.js de las features TCG (pull,
   ruleta, forja, quickview, wishlist). A diferencia de un fetch
   directo, interpreta la respuesta de error de Shopify (422:
   sin stock, variante inválida, límite alcanzado) y expone un
   mensaje legible para el usuario en err.message.
   ============================================================ */
(function () {
  'use strict';

  var FALLBACK_MSG = 'No se pudo agregar al carrito. Revisa tu conexión e inténtalo de nuevo.';

  /* Agrega items al carrito. Acepta {id, quantity} o un array de ellos.
     Resuelve con el JSON de Shopify; rechaza con Error cuyo .message es
     apto para mostrar (la descripción de Shopify si existe). */
  window.tcgAddToCart = function (items) {
    if (!Array.isArray(items)) items = [items];
    var payload = items.map(function (it) {
      return { id: Number(it.id), quantity: it.quantity == null ? 1 : Number(it.quantity) };
    });
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload })
    }).then(function (r) {
      if (r.ok) {
        return r.json().then(function (j) {
          try { document.dispatchEvent(new CustomEvent('tcg:cart:added', { detail: j })); } catch (e) { /* no-op */ }
          return j;
        });
      }
      /* Shopify responde 422 con { status, message, description } */
      return r.json().catch(function () { return null; }).then(function (j) {
        var msg = j && (j.description || j.message);
        if (msg && typeof msg === 'object') msg = null;
        var err = new Error(msg || FALLBACK_MSG);
        err.isCartError = true;
        err.status = r.status;
        err.payload = j;
        throw err;
      });
    }, function () {
      var err = new Error(FALLBACK_MSG);
      err.isCartError = true;
      throw err;
    });
  };

  /* Toast mínimo para features sin área de mensajes propia. */
  window.tcgCartToast = function (msg) {
    var t = document.createElement('div');
    t.setAttribute('role', 'status');
    t.textContent = msg || FALLBACK_MSG;
    t.style.cssText =
      'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;' +
      'max-width:min(92vw,480px);padding:.7em 1.1em;border-radius:10px;' +
      'background:#16171b;color:#f3eee4;font-size:.9rem;line-height:1.35;' +
      'box-shadow:0 8px 24px rgba(0,0,0,.35);opacity:0;transition:opacity .25s;';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    setTimeout(function () {
      t.style.opacity = '0';
      setTimeout(function () { t.remove(); }, 300);
    }, 4200);
  };
})();
